module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("The Angel\nAnswer Book")]), _vm._v(" "), _c('p', {
    staticClass: "ser1",
    staticStyle: {
      "margin-top": "15%"
    },
    attrs: {
      "id": "aap_2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/img-5-1.jpg",
      "src": "images/img-5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "pAJb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#bbp_2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#007467"
    }
  }, [_vm._v("What the Bible Says About Angels")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser3"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-20-1.jpg",
      "id": "Aop",
      "src": "images/img-20-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f3fa27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part02.vue
// module id = 72
// module chunks = 0